function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M171.398 131.181L109.546 17.5687C104.829 9.77539 96.6259 5.05859 87.5 5.05859C78.374 5.05859 70.1709 9.77539 65.4537 17.5687L3.60216 131.181C-1.11395 139.283 -1.21683 148.921 3.39777 157.021C8.01168 165.122 16.317 169.941 25.6484 169.941H149.352C158.683 169.941 166.989 165.122 171.602 157.021C176.217 148.921 176.114 139.283 171.398 131.181Z",
  fill: "#1ECD96"
}), /*#__PURE__*/React.createElement("path", {
  d: "M171.602 157.021C166.988 165.122 158.683 169.941 149.352 169.941H87.5V5.05859C96.626 5.05859 104.829 9.77573 109.546 17.5687L171.398 131.182C176.114 139.283 176.217 148.921 171.602 157.021Z",
  fill: "#1ECD96"
}), /*#__PURE__*/React.createElement("path", {
  d: "M162.579 136.411L100.727 22.7975C97.9594 18.0811 92.935 15.3125 87.5 15.3125C82.0651 15.3125 77.0407 18.0814 74.2729 22.7975L12.4206 136.411C9.54986 141.231 9.54986 147.075 12.3188 151.895C15.087 156.816 20.111 159.688 25.6488 159.688H149.352C154.889 159.688 159.914 156.816 162.682 151.895C165.45 147.075 165.45 141.231 162.579 136.411Z",
  fill: "#DEF4EC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M162.682 151.895C159.913 156.816 154.889 159.688 149.352 159.688H87.5V15.3125C92.9349 15.3125 97.9593 18.0814 100.727 22.7975L162.579 136.411C165.45 141.231 165.45 147.075 162.682 151.895Z",
  fill: "#1ECD96",
  fillOpacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  d: "M87.5 149.434C81.8474 149.434 77.2461 144.832 77.2461 139.18C77.2461 133.527 81.8474 128.926 87.5 128.926C93.1526 128.926 97.7539 133.527 97.7539 139.18C97.7539 144.832 93.1526 149.434 87.5 149.434Z",
  fill: "#1ECD96"
}), /*#__PURE__*/React.createElement("path", {
  d: "M97.7539 108.418C97.7539 114.071 93.1526 118.672 87.5 118.672C81.8474 118.672 77.2461 114.071 77.2461 108.418V57.1484C77.2461 51.4958 81.8474 46.8945 87.5 46.8945C93.1526 46.8945 97.7539 51.4958 97.7539 57.1484V108.418Z",
  fill: "#1ECD96"
}), /*#__PURE__*/React.createElement("path", {
  d: "M97.7539 139.18C97.7539 133.527 93.1526 128.926 87.5 128.926V149.434C93.1526 149.434 97.7539 144.832 97.7539 139.18Z",
  fill: "#1ECD96"
}), /*#__PURE__*/React.createElement("path", {
  d: "M97.7539 108.418V57.1484C97.7539 51.4958 93.1526 46.8945 87.5 46.8945V118.672C93.1526 118.672 97.7539 114.071 97.7539 108.418Z",
  fill: "#1ECD96"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 175,
  height: 175,
  fill: "white"
})));

var SvgMainAlert = function SvgMainAlert(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 175,
    height: 175,
    viewBox: "0 0 175 175",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMainAlert, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mainAlert.621f5bb5.svg";
export { ForwardRef as ReactComponent };